import React from "react";
import Raoul from "../Images/raoul_ghosh.png";
import Girish from "../Images/girish.png";
import Neeraj from "../Images/neeraj.png";
import { FaLinkedin } from "react-icons/fa";

const leaders = [
  {
    name: "RAOUL GHOSH",
    position: "System Design & Security",
    image: Raoul,
    color: "text-teal-500",
    description: "Rapidly fits client requirements to technologies and best practices. Specializes in internet security.",
    linkedin: "https://www.linkedin.com/company/orryworx/",
  },
  {
    name: "GIRISH KUMAR",
    position: "Cloud, IoT & Strategy",
    image: Girish,
    color: "text-teal-500",
    description: "Leads embedded development with deep cloud and IoT knowledge. Builds overall strategy for new project execution.",
    linkedin: "https://www.linkedin.com/in/kr-girish/",
  },
  {
    name: "NEERAJ TIWARI",
    position: "Engineering & Project Management",
    image: Neeraj,
    color: "text-teal-500",
    description: "Vast experience in project management. Heads engineering practice ensuring technical excellence across projects.",
    linkedin: "https://www.linkedin.com/in/neeraj-tiwari-a87b218/",
  },
];

export default function LeadershipTeam() {
  return (
    <section className="bg-white py-24 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6">
        
        {/* Heading */}
        <div className="text-center mb-24">
          <span className="inline-block text-blue-600 uppercase tracking-[4px] font-semibold">
            Leadership Team
          </span>

          <h2 className="mt-4 text-4xl md:text-5xl font-bold text-gray-900">
            Meet Our Leaders
          </h2>

          <div className="w-24 h-1 bg-blue-600 mx-auto mt-5 rounded-full"></div>

          <p className="max-w-4xl mx-auto mt-8 text-lg text-gray-600 leading-relaxed">
            Personalization is our compass, guided by the remarkable
            individuals steering our journey forward. Meet the trailblazers
            shaping our path towards a tailored experience just for you.
          </p>
        </div>

        {/* Leadership Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {leaders.map((leader, index) => (
            <div
              key={index}
              className="relative bg-[#dce7f1] rounded-3xl px-8 pt-20 pb-10 text-center transition-all duration-300 hover:-translate-y-2 hover:shadow-xl"
            >
              {/* Circular Image */}
              <div className="absolute -top-14 left-1/2 -translate-x-1/2">
                <img
                  src={leader.image}
                  alt={leader.name}
                  className="w-28 h-28 rounded-full object-cover border-4 border-white shadow-lg"
                />
              </div>

              {/* Name */}
              <h3 className="text-3xl font-bold text-gray-800">
                {leader.name}
              </h3>

              {/* Position */}
              <p className={`mt-2 text-lg font-medium ${leader.color}`}>
                {leader.position}
              </p>

              {/* Description */}
              <p className="mt-6 text-gray-600 text-lg leading-relaxed">
                {leader.description}
              </p>

              {leader.linkedin && (
                <a
                  href={leader.linkedin}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center gap-2 mt-5 text-blue-600 hover:text-blue-800 transition font-medium"
                >
                  <FaLinkedin size={22} /> LinkedIn
                </a>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}